import styled from 'styled-components'

export const StyledBanner = styled.div`
  width: 100%;
  background: ${p => p.theme.webMktPalette.background.white};
  padding: 4px 0;
  box-sizing: border-box;
  position: relative;
  display: ${(p: any) => (p.displayBanner ? 'block' : 'none')};
  ${p => p.theme.breakpoints.down('sm')} {
    padding: 4px 16px;
  }

  .localizedBanner_text {
    text-align: center;
    ${p => p.theme.breakpoints.down('sm')} {
      padding-right: 20px;
    }
  }

  .localizedBanner_x-btn {
    position: absolute;
    right: 15px;
    top: 6px;
    cursor: pointer;
  }
`
